<template>
  <v-expansion-panel dark inset>
    <v-expansion-panel-content v-for="(item, index) in items" :key="index">
      <div slot="header">
        <h2>{{ item.lHeader }}</h2>
        <p>{{ item.rHeader }}</p>
        <p v-if="item.description">{{ item.description }}</p>
      </div>
      <v-list>
        <template v-for="lItem in item.tasks">
          <v-divider :key="lItem"></v-divider>
          <v-list-tile :key="lItem">
            <v-list-tile-content>
              <v-list-tile-title v-html="lItem"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "ResumeEducation",
  data() {
    return {
      items: [
        {
          lHeader:
            "Bachelor of Science in Electrical & Computer Engineering, Univerity of Colorado Boulder",
          rHeader: "August 2012 - May 2016",
          tasks: [
            "Data Structures",
            "Operating Systems",
            "C Programming for Electrical Engineers",
            "Digital Signal Processing"
          ],
          description: null,
          link: ""
        }
      ]
    };
  }
};
</script>

<style scoped></style>
